module.exports = __webpack_public_path__ + "img/mlogo.0adb1df5.png";